// Module
var code = "<contractor-project-types-group group=\"group\" update=\"$ctrl.updateGroupProjectTypesOffered(groupId, projectTypesOffered)\" ng-repeat=\"group in $ctrl.groups track by group.id\" ng-class=\"{ hidden: group.id === 0 }\"></contractor-project-types-group> ";
// Exports
module.exports = code;